export default __webpack_public_path__ + "static/media/img_payment_methods.c5a9df9e.svg";